module.exports = __webpack_public_path__ + "img/6.4f81b8ee.jpg";